import React, {useEffect, useCallback} from 'react';

export const useWindowClearer = ({clear, selected}) => {
    useEffect(() => {
        window.addEventListener('mousedown', onWindowDown);
        return () => window.removeEventListener('mousedown', onWindowDown);
    }, [clear]);

    const onWindowDown = useCallback(() => {
        if (selected) {
            clear();
        }
    }, [clear, selected]);

};
